<template>
    <section class="col-12 margin-b-150">

        <header class="col-12 padding-b-25">
            <label>Tilføj nyt tilbehør</label>
        </header>

        <form class="col-12" @submit.prevent="submitItem">

            <section class="col-12 margin-b-50">

                <label>Navn</label>

                <input class="col-12" type="text" name="title" placeholder="Hvad er navnet?" minlength="2" maxlength="120" required v-model="title">

            </section>

            <section class="col-12">

                <button type="submit" class="btn btn--sm btn--primary primary--copper" :disabled="!validateForm || isSaving">

                    <span v-if="isSaving"><i class="spinner--light"></i> Opretter</span>

                    <span v-else>Opret</span>

                </button>

                <a href="#" @click.prevent="$emit('toIndex')">Annuller</a>

            </section>

        </form>

    </section>

</template>

<script>
export default {
    name: "create",
    data(){
        return {
            title:'',
            isSaving:false,
        }
    },
    props:['items'],
    computed:{
        validateTitle() {
            return this.title !== '' && String(this.title).length > 0;
        },
        validateForm(){
            return this.validateTitle;
        }
    },
    methods:{
        submitItem(){
            if(!this.validateForm) return;

            let newItems = [...this.items];
            newItems.push(this.title);
            this.title = '';

            this.$emit('updateItems', newItems);
            this.$emit('toIndex');
        }
    }
}
</script>

<style scoped>

</style>
